<div
  class=" border-2 border-solid border-green-700 my-1 w-full  px-4 py-2 mb-4 rounded-md shadow-[0px_0px_7px_-2px_rgba(0,0,0,0.5)]">
  <div class="flex items-center flex-row justify-between mb-2">
    <div>
      <p class="md:text-base text-sm font-semibold">{{auditInput.FlattenedQuestions[0].AuditName}}</p>
      <h4 class="md:text-base text-sm font-semibold"><span
          class="text-base text-green-400 mr-1">&#64;</span>{{auditInput.Location.LocationName}}</h4>
    </div>
    <div class="flex flex-row pl-1">
      @if(auditInput.CloudSave && hasAlt){
      <span
        class="material-symbols-outlined text-3xl align-bottom  self-center text-green-300 cursor-pointer">cloud_sync</span>
      }
      @if(auditInput.CloudSave && !hasAlt){
      <span
        class="material-symbols-outlined text-3xl align-bottom  self-center text-green-300 cursor-pointer">cloud</span>
      }
      @if(!auditInput.CloudSave) {
      <span
        class="material-symbols-outlined text-3xl align-bottom  self-center text-green-300 cursor-pointer">hard_drive</span>
      }

    </div>
  </div>
  <div class="border-t-[1px] border-t-grey-300 w-full"></div>
  @if (false) {
  <div class="my-2">
    <p>Started: <strong>{{auditStartedAgo}}</strong></p>
    <p>Incomplete Questions: <strong>{{incompleteQuestions}}</strong></p>
    @if (hasReference) {
    <p>Reference: <strong>{{reference}}</strong></p>
    }
    @if (hasRemainingQuestions) {
    <p>Incomplete Required Questions:
      <strong>{{remainingQuestions}} </strong>
    </p>
    }
  </div>
  }
  <div class="mt-2 flex flex-col md:flex-row justify-between md:justify-normal">
    <div class="md:w-1/3">
      <p class="text-green-400 mr-2 text-sm">{{ 'audit' | customerTerm }} Started</p>
      <div class="flex items-baseline px-2">
        <p class="mr-1">{{auditStartedAgo}}</p>
        <p class="text-sm">&#40;{{auditStarted}}&#41;</p>
      </div>
    </div>
    <div class="mt-2 md:mt-0 md:flex-grow flex justify-end  md:border-l-grey-500 md:border-l-[1px] md:pl-2">
      <div class="flex justify-center items-center md:mr-8">
        <p class="text-green-700 mr-1">Completion Progress</p>
        <app-progress-bar [Score]="completionProgressScore" [MaxScore]="completionProgressMaximum"></app-progress-bar>

      </div>

    </div>
    <div class="flex-col justify-center flex my-2">
      <button class="btn-primary  text-sm flex items-center justify-center" [disabled]="showDelete || showCloudWarning"
        (click)="checkAudit()">Continue {{ 'audit' | customerTerm }} <span
          class="material-symbols-outlined text-sm">chevron_right</span></button>
      <button class="btn-caution text-sm mt-2" [disabled]="showDelete || showCloudWarning"
        (click)="switchDeleteStatus()">Remove
        {{ 'audit' | customerTerm }}</button>
    </div>
  </div>
  @if (showDelete) {
  <div class="my-6 p-3 border-grey-300 border-2 rounded-md mx-4">
    <h4>Confirm {{ 'audit' | customerTerm }} Removal</h4>
    <p>Once the audit has been removed from your current audits it <strong>cannot be recovered!</strong></p>
    <div class="flex my-5">
      <button class="btn-primary btn-negative mr-2" (click)="removeAudit()" [disabled]="currentlyDeleting">@if
        (!currentlyDeleting) {
        <span>Confirm Delete</span>
        }@if (currentlyDeleting) {
        <span>Updating...</span>
        }</button>
      <button class="btn-inverse" (click)="switchDeleteStatus()">Cancel</button>
    </div>
  </div>
  }
  @if(showCloudWarning){
  <div class="my-6 p-3 border-grey-300 border-2 rounded-md mx-4">
    <h4>Select {{ 'audit' | customerTerm }}</h4>
    <p class="mt-2 text-offblack">This audit on your device is missing your latest changes. Continue with the local version or load your most recent progress from the cloud.</p>
    <div class="flex justify-around flex-col md:flex-row gap-4 mt-6 mb-4">
      <div class="py-2 flex justify-center w-full md:w-[50%]">
        <div class="border-green-500 border-green-2 w-full shadow-md rounded-xl p-3">
          <div class="flex justify-between">
            <h4>Local Save</h4>
            <span
              class="material-symbols-outlined text-3xl align-bottom  self-center text-green-300 cursor-pointer">hard_drive</span>
          </div>

          <p class="mt-2 font-semibold">Last Save</p>
          <div class="flex items-baseline">
            <p class="mr-1">{{altAuditEditAgo}}</p>
            <p class="text-sm">&#40;{{altAuditEdit}}&#41;</p>
          </div>
          <button class="btn-primary btn-primary mt-4 w-full" (click)="forceLocalLoad()">Select Local</button>
        </div>
      </div>
      <div class="py-2 flex justify-center w-full md:w-[50%]">
        <div class="border-green-900 border-green-2 shadow-md  w-full rounded-xl p-3">
          <div class="flex justify-between">
            <h4>Cloud Save</h4>
            <span
              class="material-symbols-outlined text-3xl align-bottom  self-center text-green-300 cursor-pointer">cloud</span>
          </div>

          <p class="mt-2 font-semibold">Last Save</p>
          <div class="flex items-baseline">
            <p class="mr-1">{{auditEditAgo}}</p>
            <p class="text-sm">&#40;{{auditEdit}}&#41;</p>
          </div>
          <button class="btn-primary btn-primary mt-4 w-full" (click)="jumpToAudit()">Select Cloud</button>
        </div>
      </div>

    </div>

  </div>
  }
</div>
